import React from 'react';

const steps = [
  {
    title: 'Upload Your Resources',
    description: 'Add the documents, FAQs, and content your audience relies on.',
    image: '/images/process/upload.png',
  },
  {
    title: 'Customize Your Assistant',
    description: 'Set the look, tone, and rules that fit your organization.',
    image: '/images/process/customize.png',
  },
  {
    title: 'Embed and Share',
    description: 'Place CLEONA on your website or share it with a simple link.',
    image: '/images/process/embed.png',
  }
];

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Section header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-16">
          <div>
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="text-cleona-600 font-manrope font-semibold text-sm">Launch Your Smart Assistant™</span>
              <span className="flex items-center justify-center w-6 h-6 rounded-full bg-cleona-600">
                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clipRule="evenodd" />
                </svg>
              </span>
            </div>
            <h2 className="font-jakarta text-4xl font-bold text-gray-900 sm:text-5xl">
              Launch Your Smart<br />Assistant in Minutes
            </h2>
          </div>
          <p className="mt-6 lg:mt-0 max-w-md text-gray-600 font-manrope lg:text-right">
            CLEONA is built for non-technical users. Get up and running in three simple steps.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="group">
              {/* Step image */}
              <div className="mb-6">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
